import { Flex, Heading, Image, Text } from "@chakra-ui/react";
import { generatePath, Link } from "react-router-dom";
import React from "react";

const InfoCard = ({ noticia }) => {
  return (
    <>
      {noticia.video && noticia.description ? (
        <Link
          className="link"
          to={generatePath("/novedades/:id", { id: noticia._id })}
        >
          <Flex
            backgroundImage={noticia.photo}
            w="650px"
            h="300px"
            backgroundPosition="center"
            backgroundSize="cover"
            backgroundRepeat="no-repeat"
            m="50px"
            p="1.5px"
            transform="rotate(-2deg)"
            transition="transform, 0.5s"
            boxShadow="2px 4px 15px 1px rgba(0,0,0,0.82)"
            borderRadius="10px"
            _hover={{
              width: "670px",
              height: "320px",
              margin: "35px",
              transform: "rotate(0deg)",
              transition: "all, 0.3s",
            }}
          >
            <Image
              w="100px"
              position="absolute"
              right="0"
              mt="-25px"
              src="/assets/chincheta.png"
              alt="chincheta"
            />
            <Flex
              backgroundColor="#FFFFFF"
              w="250px"
              h="95%"
              m="10px"
              justify="center"
              align="center"
              flexDir="column"
              borderRadius="10px"
            >
              <Text
                textAlign="center"
                fontSize="large"
                w="100%"
                mb="25px"
                p="15px"
              >
                {noticia.shortDescription}
              </Text>
              <Heading textAlign="center" w="100%" m="5px" fontSize="25px">
                {noticia.title}
              </Heading>
            </Flex>
          </Flex>
        </Link>
      ) : (
        <Flex
          backgroundImage={noticia.photo}
          w="650px"
          h="300px"
          backgroundPosition="center"
          backgroundSize="cover"
          backgroundRepeat="no-repeat"
          m="50px"
          p="1.5px"
          transform="rotate(-2deg)"
          transition="transform, 0.5s"
          boxShadow="2px 4px 15px 1px rgba(0,0,0,0.82)"
          borderRadius="10px"
          _hover={{
            width: "670px",
            height: "320px",
            margin: "35px",
            transform: "rotate(0deg)",
            transition: "all, 0.3s",
          }}
        >
          <Image
            w="100px"
            position="absolute"
            right="0"
            mt="-25px"
            src="/assets/chincheta.png"
            alt="chincheta"
          />
          <Flex
            backgroundColor="#FFFFFF"
            w="250px"
            h="95%"
            m="10px"
            justify="center"
            align="center"
            flexDir="column"
            borderRadius="10px"
          >
            <Text
              textAlign="center"
              fontSize="large"
              w="100%"
              mb="25px"
              p="15px"
            >
              {noticia.shortDescription}
            </Text>
            <Heading textAlign="center" w="100%" m="5px" fontSize="25px">
              {noticia.title}
            </Heading>
          </Flex>
        </Flex>
      )}
    </>
  );
};

export default InfoCard;
